// components/inventory/InventoryCard.jsx
import React from 'react';
import ActionButtons from './ActionButtons';

const InventoryCard = ({ 
  inventory, 
  index, 
  onView, 
  onEdit, 
  onAddItem, 
  onShare, 
  onDelete 
}) => {
  const totalItems = inventory.inventoryList?.length || 0;
  const totalQuantity = inventory.inventoryList?.reduce((sum, item) => sum + item.totalQuantity, 0) || 0;

  return (
    <div className="bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow">
      <div className="p-4">
        {/* Inventory Icon/Image */}
        <div className="flex justify-center mb-4">
          <div className="w-16 h-16 bg-gray-100 rounded-lg flex items-center justify-center overflow-hidden">
            {inventory.inventoryImage ? (
              <img 
                src={inventory.inventoryImage} 
                alt={inventory.inventoryName} 
                className="w-full h-full object-cover" 
              />
            ) : (
              <div className="text-blue-600 font-bold text-lg">
                {inventory.inventoryName.charAt(0).toUpperCase()}
              </div>
            )}
          </div>
        </div>
        
        {/* Inventory Name */}
        <h3 className="font-semibold text-gray-800 text-center mb-2 truncate">
          {inventory.inventoryName}
        </h3>
        
        {/* Description */}
        <p className="text-sm text-gray-600 text-center mb-4 line-clamp-2">
          {inventory.description || 'No description'}
        </p>

        {/* Stats */}
        <div className="text-center mb-4 space-y-1">
          <div className="text-sm text-gray-500">
            {totalItems} items
          </div>
          <div className="text-xs text-gray-400">
            Total Qty: {totalQuantity}
          </div>
        </div>

        {/* Action Buttons */}
        <ActionButtons
          onView={() => onView(index)}
          onEdit={() => onEdit(index)}
          onAddItem={() => onAddItem(index)}
          onShare={() => onShare(index)}
          onDelete={() => onDelete(index)}
        />
      </div>
    </div>
  );
};

export default InventoryCard;